import {
    NotificationTypeSuccess,
    NotificationTypeError,
    NotificationTypeWarning,
    NotificationTypeInfo,
    NotificationResponse
} from "./shared.gen";

const NotificationTypeMap = {
    success: NotificationTypeSuccess,
    warning: NotificationTypeWarning,
    error: NotificationTypeError,
    info: NotificationTypeInfo,
}

type ToastType = typeof NotificationTypeMap[keyof typeof NotificationTypeMap];

interface Toast {
    id: number;
    message: string;
    type: ToastType;
    visible: boolean;
}

export class ToastHandler {
    private evtSource: EventSource | undefined;
    public toasts: Toast[] = [];

    public addEventSource(evtSource: EventSource) {
        this.evtSource = evtSource;
        this.register();
    }

    public register() {
        if (!this.evtSource) return;

        this.evtSource.addEventListener("toast", (event: MessageEvent) => {
            const data: NotificationResponse = JSON.parse(event.data);
            if (data && data.message && data.notification_type) {
                this.add(data.message, data.notification_type, data.notification_duration || 2000);
            }
        });
    }

    public start(): void {
        console.log('ToastHandler started');
    }

    // Public so a screen can report something that happened in the browser and
    // never reached the server, such as a value copied to the clipboard. The
    // server path raises toasts over the event stream; this is the same queue,
    // so both kinds look and behave alike.
    public add(message: string, type: ToastType = 'success', duration: number = 3000): void {
        const id = Date.now() + Math.random();
        const toast: Toast = {
            id,
            message,
            type,
            visible: true,
        };
        this.toasts.push(toast);

        setTimeout(() => {
            this.removeById(id);
        }, duration);
    }

    private remove(index: number): void {
        this.toasts[index].visible = false;
        setTimeout(() => {
            this.toasts.splice(index, 1);
        }, 300);
    }

    private removeById(id: number): void {
        const index = this.toasts.findIndex((t) => t.id === id);
        if (index !== -1) this.remove(index);
    }
}
